import { render, staticRenderFns } from "./echartPie.vue?vue&type=template&id=3151f683"
import script from "./echartPie.vue?vue&type=script&lang=js"
export * from "./echartPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports